<template>
	<div class="content_category">
		<button
			v-for="(item, index) in props.items"
			:key="index"
			:class="(currentSort === item || (currentSort === '' && index === 0)) && 'on'"
			@click="onClickCategory(item)"
		>
			{{ item }}
		</button>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

// -----variable-----
const props = defineProps<{
	items: string[];
	sort?: string;
	queryKey: string | number;
}>();
const emit = defineEmits(['click-category']);

const router = useRouter();
const route = useRoute();

const currentSort = computed(() => route.query[`sort${props.queryKey}`] ?? props.items[0]);

// -----function-----
const onClickCategory = (sort: string) => {
	router.replace({ query: { ...route.query, [`sort${props.queryKey}`]: sort } });
	emit('click-category', sort);
};
</script>

<style scoped lang="scss">
.content_category {
	display: flex;
	gap: 1rem;
	overflow: scroll;
	@media screen and (max-width: 1280px) {
		padding: 0rem 2rem;
	}
	button {
		border: 1px solid var(--color-base-mid);
		border-radius: 0.6rem;
		font-size: var(--font-s-mid);
		font-weight: var(--font-w-semi-bold);
		line-height: normal;
		color: var(--color-font-white);
		white-space: nowrap;
		padding: 1.3rem 1.6rem;
	}
	.on {
		border: 1px solid var(--color-primary);
		color: var(--color-primary);
	}
}

.content_category::-webkit-scrollbar {
	display: none;
}
</style>
